<template>
  <div class="uk-card-default rounded text-center p-4 user-information">
    <div class="user-profile-photo m-auto">
      <img :src="userData.photo_link" alt="">
    </div>
    <h4>{{ userData.fullname }}<br> <span style="font-size:1rem;color:#a08383;">#{{
      userData.id
    }}</span></h4>
    <button class="btn btn-soft-primary mb-2 btn-block" type="button" @click.prevent="$emit('openMessageModal')">
      <i class="uil-envelope-alt"></i>{{ $t('general.send_message') }}
    </button>
    <button v-if="socialPostVisible" class="btn btn-soft-primary btn-block" type="button"
      @click.prevent="$router.push({ name: 'company.user.wall', params: { user: userData.id } })">
      <i class="uil-coffee"></i> {{ $t('general.look_wall') }}
    </button>
    <button class="btn btn-soft-primary mb-2 btn-block" type="button"
      @click.prevent="$router.push({ name: 'company.user.statistics', params: { user: userData.id } })">
      <i class="uil-chart-pie"></i>
      {{ $t('general.statistics') }}
    </button>

    <button class="btn btn-soft-primary mb-2 btn-block" @click="$emit('showAddCertificate')">
      {{ $t('certificate.add') }}
    </button>

    <button class="btn btn-soft-primary mb-2 btn-block" @click="$emit('showUserCompetencies')">
      {{ $t('general.show_competencies') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'UserProfileCard',
  props: {
    userData: {
      type: Object,
      required: true
    },
    socialPostVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.user-information {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.user-profile-photo {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 16px;
  border: 4px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-profile-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-information h4 {
  font-size: 18px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 8px;
  line-height: 1.4;
}

.user-information h4 span {
  font-size: 13px !important;
  color: #718096 !important;
  font-weight: 500;
}

.user-information .btn {
  font-size: 13px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  border: none;
}

.user-information .btn i {
  font-size: 16px;
  margin-right: 6px;
}

.user-information .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .user-profile-photo {
    width: 100px;
    height: 100px;
    border-width: 3px;
  }

  .user-information h4 {
    font-size: 17px;
  }

  .user-information h4 span {
    font-size: 14px !important;
  }

  .user-information .btn {
    font-size: 14px;
    padding: 12px 16px;
    min-height: 48px;
  }
}
</style>
